/* eslint-disable no-console */
import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { getFeatureFlag } from '../../common/Utils';
import { returnSuppressFlag } from '../../utils/featureSuppress';
import { useLagoon } from '../useLagoon';

export const useWidgetSmartChoice = (
  isSmartChoiceEnabled: boolean,
  coverageType: string
) => {
  const featureFlags: [{ key: string; active: boolean }] =
    useLagoon('feature-flags')();

  const enablePSXProviderRecommendations = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_PSX_PROVIDER_RECOMMENDATIONS
  );
  const isSmartChoiceSuppressed = returnSuppressFlag(
    ConstantsLagoon.FEATURE_SUPPRESSION_FLAGS.SMART_CHOICE
  );
  console.log({
    isSmartChoiceEnabled,
    coverageType,
    enablePSXProviderRecommendations,
    isSmartChoiceSuppressed,
  });
  const baseCondition =
    !isSmartChoiceSuppressed &&
    enablePSXProviderRecommendations &&
    coverageType === 'M' &&
    isSmartChoiceEnabled;
  console.log({ baseCondition });
  return baseCondition;
};
